import type { HTTPClientResponse } from "services/ciq-client";

type ApiErrorBody = {
  error?: unknown;
  message?: unknown;
};

export function getCiqClientErrorMessage(
  response: Pick<HTTPClientResponse, "error" | "errorMsg"> | null | undefined,
  fallback: string
): string {
  const body = response?.error?.response?.data as ApiErrorBody | undefined;

  if (typeof body?.error === "string" && body.error.trim()) {
    return body.error;
  }

  if (typeof body?.message === "string" && body.message.trim()) {
    return body.message;
  }

  if (typeof response?.errorMsg === "string" && response.errorMsg.trim()) {
    return response.errorMsg;
  }

  return fallback;
}
